import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Organization } from "../types/modules/organization.type";

export interface OrganizationState {
    accessToken: string;
    organization: Organization | null;
}

const initialState: OrganizationState = {
    accessToken: "",
    organization: null,
};

const organizationSlice = createSlice({
    name: "organization",
    initialState,
    reducers: {
        loginOrganization(
            state,
            action: PayloadAction<{ accessToken: string; organization: Organization }>
        ) {
            state.accessToken = action.payload.accessToken;
            state.organization = action.payload.organization;
        },
        logoutOrganization(state) {
            state.accessToken = "";
            state.organization = null;
        },
    },
});

export const { loginOrganization, logoutOrganization } = organizationSlice.actions;
export default organizationSlice.reducer;
